/**
 * 实名认证弹框
 * 
 */
import React, { Component } from "react";
import platform from "Pub/js/platform";
import { connect } from "react-redux";
import { langCheck } from "Pub/js/utils.js";
const { ajax, toast } = platform;
const { NCButton, NCModal } = platform.base;
import { bindSuccess } from "Store/appStore/action";
import { setStore } from "Pub/js/storageUtils";
import './index.less';
import { SizeMe } from "react-sizeme";

class RealNameAuthentication extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            realMsg: '',
            contentWidth: 0
        }
    }
    componentDidMount() {
        this.bindInit().then((data) => {
            this.setState({ realMsg: data && data.realMsg || 0 })

        });
    }
    bindInit = () => {
        return new Promise((resolve, reject) => {
            ajax({
                url: `/nccloud/baseapp/yht/bindinit.do`,
                info: {
                    name: langCheck("0000PUB-000211") /* 国际化处理： 首页*/,
                    action: langCheck("0000PUB-000212") /* 国际化处理： 首页激活弹窗*/
                },
                success: ({ data, success }) => {
                    resolve(data);
                }
            })
        })

    }
    renderContent = (num) => {
        const { contentWidth } = this.state;
        return <div className="modal-content" style={{ width: contentWidth }}>
            <p className="auth-title">{langCheck("0000PUB-000614")}</p>
            <div className="auth-content">
                <p className="auth-desc">
                    {/* "0000PUB-000615": "您的帐号未进行实名认证，不符合相关法律法规要求，请及时完成实名认证。 */}
                    {langCheck("0000PUB-000615")}
                    {/* "0000PUB-000620": "了解法律法规" */}
                    <span className="auth-laws" onClick={() => {
                        window.open('https://flk.npc.gov.cn/detail2.html?MmM5MDlmZGQ2NzhiZjE3OTAxNjc4YmY4Mjc2ZjA5M2Q%3D')
                    }}>{langCheck("0000PUB-000620")}</span>
                </p>
            </div>
            {/* "温馨提示：您还可登录{num}次旗舰版！" */}
            {/* <p>
                {langCheck("0000PUB-000621", false, null, [num])}
            </p> */}
        </div>
    }
    closeModal = () => {
        setStore('isRealName', true);
        this.setState({
            visible: false
        })
    }
    attestationLater = () => {
        this.closeModal();
    }
    isAttestation = () => {
        // const { updateAPPDataStore } = this.props;
        // updateAPPDataStore && typeof (updateAPPDataStore) === 'function' && updateAPPDataStore();
        this.bindInit().then((data) => {
            if (data) {
                // /realMsg realStatus为1的时候 会返回提示信息 "用户没有实名认证，还可登录28次"
                //  0  是已实名认证
                if (+data.realStatus === 0) {
                    setStore('isRealName', true);
                    this.setState({
                        visible: false
                    })
                } else {
                    toast({ content: langCheck('0000PUB-000626' /* 未查到您的认证信息！ */), color: 'warning' });
                }
            }
        })
    }
    attestationNow = () => {
        window.open('https://euc.yonyoucloud.com/usercenter/usermng');
    }
    render() {
        const { realMsg, visible, contentWidth } = this.state;
        return (
            <NCModal
                show={visible}
                // size='small'
                minWidth={376}
                width='auto'
                minHeight={197}
                height='auto'
                resizable={false}
                dialogClassName='real-name-authentication-modal'
            >
                <NCModal.Body className="real-auth-body">
                    { contentWidth && this.renderContent(realMsg)}
                    <SizeMe>
                        {
                            ({ size }) => {
                                if (contentWidth !== size.width) {
                                    this.setState({ contentWidth: size.width })
                                }
                                return <div className="auth-btns">
                                    <NCButton onClick={this.attestationNow} colors="primary">
                                        {/* // 立即认证  */}
                                        {langCheck("0000PUB-000619")}
                                    </NCButton>
                                    <NCButton onClick={this.isAttestation}>
                                        {/* // "0000PUB-000623": "我已认证"  */}
                                        {langCheck("0000PUB-000623")}
                                    </NCButton>
                                    <span className="text-button" onClick={this.attestationLater}>
                                        {/* // 以后认证  */}
                                        {langCheck("0000PUB-000618")}
                                    </span>
                                </div>
                            }
                        }
                    </SizeMe>
                </NCModal.Body>
            </NCModal>
        );
    }
}

export default connect(null, { bindSuccess })(RealNameAuthentication);
